export default __webpack_public_path__ + "static/media/work4.eca7e80c.png";